import { type MeResponse, type PermissionCode, isAdminRole } from "@seagames/contracts";
import { groupGrants } from "../../lib/travel/access";

/**
 * Who sees what of the Helpdesk (PLAN §3.1). NONE of this decides anything:
 * `ticketVisible` / `ticketWritable` in SQL do, and the API re-checks every
 * write. It only picks the pages, buttons and forms to draw.
 *   handle  admins, a host desk group or a HOTEL group with `helpdesk.handle`
 *           — the queue, New ticket, status and notes
 *   report  a group with `helpdesk.report` (a NOC) — its own organisation's
 *           tickets and "Report a room problem"
 */
type Session = Pick<MeResponse, "active_role" | "group">;

export const HELPDESK_PAGE_PERMISSIONS = ["helpdesk.handle", "helpdesk.report"] as const satisfies readonly PermissionCode[];

export const canHandleHelpdesk = (me: Session): boolean => isAdminRole(me.active_role) || groupGrants(me, "helpdesk.handle");

/** Reporting only: a NOC (a handler sees and opens everything already). */
export const isHelpdeskReporter = (me: Session): boolean => !canHandleHelpdesk(me) && groupGrants(me, "helpdesk.report");

export const canSeeHelpdesk = (me: Session): boolean => canHandleHelpdesk(me) || isHelpdeskReporter(me);

/** The organisation a reporter reports for: its group's scope rows name it (a NOC group has one). */
export function reporterOrganization(me: Session): { id: string; name: string } | null {
	const scope = me.group?.scopes.find((s) => s.responsible_organization);
	return scope?.responsible_organization ? { id: scope.responsible_organization.id, name: scope.responsible_organization.name } : null;
}

/** A HOTEL's buildings (its group's facility rows), for the building filter and New ticket. */
export function hotelBuildingIds(me: Session): string[] {
	if (me.active_role !== "HOTEL") return [];
	return (me.group?.facilities ?? []).flatMap((f) => (f.lodging_building ? [f.lodging_building.lodging_building_id] : []));
}
